import React, { useState, useEffect } from "react";
import "./SellerListByAcceptingJob.less"
import { Container, Pagination, Table, TableRow, Message, Dimmer, Modal, Loader, Grid, Icon } from "semantic-ui-react";
import { getSellersNotAcceptingJobList } from "services/Manager";
import { saveSellerDetail } from 'services/Seller';
import moment from "moment";
import Formsy from "formsy-react";
import DGTextarea from "components/FormControls/Textarea/DGTextarea";

const SellerListByAcceptingJob = () => {
    const [sellerData, setSellerData] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [activePage, setActivePage] = useState(1);
    const [totalRecordCount, setTotalRecordCount] = useState(0);
    const [message, setMessage] = useState('')
    
    const [sellerInfoModalOpen, setSellerInfoModalOpen] = useState(false);
    const [selectedSellerName, setSelectedSellerName] = useState('');
    const [selectedSellerID, setSelectedSellerID] = useState(0);
    const [savingSellerInfo, setSavingSellerInfo] = useState(false);
    const [selectedAdditionalInfo, setSelectedAdditionalInfo] = useState('');


    useEffect(() => {
        getSellersNotAcceptingJobs();
    }, [activePage]);

    useEffect(() => {
        if (message) {
            setTimeout(() => {
                setMessage('')
            }, 5000);
        }
    }, [message]);

    const getSellersNotAcceptingJobs = async () => {
        const res = await getSellersNotAcceptingJobList(activePage, 20);
        if(res && res.resStatus == 200)
        {
            setSellerData(res.data.sellerData);
            setTotalRecordCount(+res.data.count);
            const numberOfPages = Math.ceil(+res.data.count / 20);
            setTotalPages(numberOfPages);
        }
        else
        {
            setMessage(res.message)
        }
    }

    const onPageChange = (e, data) => {
        setActivePage(data.activePage);
        
    }

    const onShowSellerInfoModal = (sellerName, sellerID, additionalInfo) => {
        setSelectedSellerName(sellerName);
        setSelectedSellerID(sellerID);
        setSelectedAdditionalInfo(additionalInfo);
        setSellerInfoModalOpen(true);
       
    }

    const onSellerInfoModalClose = () => {
        setSellerInfoModalOpen(false);
    }

    const onValidSellerInfoSave = async () => {
        const res = await saveSellerDetail(selectedSellerID, {additionalInfo : selectedAdditionalInfo});
        if(res && res.resStatus == 200)
        {
            getSellersNotAcceptingJobs();
            setSellerInfoModalOpen(false);
        }
        else
        {
            setMessage(res.message);
        }
    }
    
    const onAdditionalInfoChange = (e, data) => {
        setSelectedAdditionalInfo(data.value);
    }


    return (
        <Container fluid className="review-list-container">
            <div className="main-page-panel">
                <div className="content-panel">
                    <div className="mobile-header">
                        <div className="main-heading">
                            Not Accepting Jobs
                        </div>
                    </div>
                    {message ? <Message>
                    <Message.Header>Error:</Message.Header>
                    <p>
                        {message}
                    </p>
                    </Message> : ''}
                    <Table>
                        <Table.Header className="seller-table-header">
                            <Table.Row>
                                <Table.HeaderCell className="name-cell">
                                    Name
                                </Table.HeaderCell>
                                <Table.HeaderCell className="name-cell">
                                    Email
                                </Table.HeaderCell>
                                <Table.HeaderCell className="phone-cell">
                                    Phone
                                </Table.HeaderCell>
                                <Table.HeaderCell className="subType-cell">
                                    Sub Type
                                </Table.HeaderCell>
                                <Table.HeaderCell className="offSince-cell">
                                    Off Since
                                </Table.HeaderCell>
                                <Table.HeaderCell className="days-cell">
                                    Days Off
                                </Table.HeaderCell>
                                <Table.HeaderCell className="notes-cell">
                                    Notes
                                </Table.HeaderCell>
                                {/* <Table.HeaderCell className="edit-cell">
                                </Table.HeaderCell> */}

                            </Table.Row>
                        </Table.Header>
                        <Table.Body className="seller-table-body">
                            {sellerData.length == 0 && <TableRow>
                                <Table.Cell colSpan={4}>
                                    No records found
                                </Table.Cell>
                            </TableRow>}

                            {sellerData.length > 0 && _.map(sellerData, (item) => {
                                return <Table.Row>
                                    <Table.Cell className="table-cell">
                                        {item.name}
                                    </Table.Cell>
                                    <Table.Cell className="table-cell">
                                        {item.email}
                                    </Table.Cell>
                                    <Table.Cell className="table-cell">
                                        {item.cellPhone}
                                    </Table.Cell>
                                    <Table.Cell className="table-cell">
                                        {item.subType}
                                    </Table.Cell>
                                    <Table.Cell className="table-cell">
                                        {item.acceptingJobsLastUpdatedOn ? moment(item.acceptingJobsLastUpdatedOn).format('LL') : "-"}
                                    </Table.Cell>
                                    <Table.Cell className="table-cell">
                                        {item.acceptingJobsLastUpdatedOn ? moment().diff(moment(item.acceptingJobsLastUpdatedOn), 'days') + ' days' : "-"}
                                    </Table.Cell>
                                    <Table.Cell className="table-cell">
                                        {/* <div className="notes-div">
                                            {item.additionalInfo}
                                        </div> */}
                                        {item.additionalInfo && _.trim(item.additionalInfo).length > 0 ?<> <div className="notes-div">{item.additionalInfo} </div><span><Icon name="pencil" style={{color: '#21ba45', cursor: 'pointer'}} size='small' onClick={() => onShowSellerInfoModal(item.name, item.sellerID, item.additionalInfo)} /></span></> : 
                                                    <Icon name="sticky note outline" style={{color: '#21ba45', cursor: 'pointer'}} size='large' onClick={() => onShowSellerInfoModal(item.name, item.sellerID, item.additionalInfo)} /> }
                                                
                                    </Table.Cell>
                                    {/* <Table.Cell className="table-cell edit-btn-cell">
                                        <button type="button" className="button-submit" onClick={() => onShowSellerInfoModal(item.name, item.sellerID, item.additionalInfo)}>Edit</button>
                                    </Table.Cell> */}

                                </Table.Row>
                            })
                            }
                        </Table.Body>
                    </Table>
                    <Pagination totalPages={totalPages} activePage={activePage} disabled={totalRecordCount == 0 || totalRecordCount <= 20} onPageChange={onPageChange} />
                </div>

                <Modal className="seller-info-modal-container"
                    closeOnDimmerClick={false}
                    closeOnEscape={false}
                    onClose={onSellerInfoModalClose}
                    open={sellerInfoModalOpen}
                    closeIcon>
                    <Modal.Header className="sellerInfo-modal-header">
                        {selectedSellerName}
                    </Modal.Header>
                    <Dimmer.Dimmable as={Modal.Content} blurring dimmed={savingSellerInfo}>
                        <Dimmer active={savingSellerInfo} inverted>
                            <Loader>Saving</Loader>
                        </Dimmer>
                        <Formsy onValidSubmit={onValidSellerInfoSave}>

                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                        <DGTextarea
                                            name="additionalInfo"
                                            value={selectedAdditionalInfo}
                                            maxLength={512}
                                            label="Additional Details"
                                            onChange={onAdditionalInfoChange} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                        <button className="button-submit">Save</button>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Formsy>
                    </Dimmer.Dimmable>
                </Modal>

            </div>

        </Container>
    )

}

export default SellerListByAcceptingJob;